import { ChangeDetectionStrategy, Component } from '@angular/core'
import { StatusContext } from 'src/app/account/components/app-resources-view/app-resources-view.component'
import { ResourcesTab } from 'src/app/account/components/application/resources-tab'
import { Application } from 'src/app/account/services/application.service'
import { BackupScreenScenario, buildBackupScreenScenarios } from '../../mocks/showcase-backup-screen-mocks'

/**
 * Backup-tab counterpart to the Recovery screens. Simpler composition: no sub-tabs
 * and no operation notice, because the Backup tab renders neither.
 */
@Component({
  selector: 'showcase-backup-screen',
  templateUrl: './showcase-backup-screen.component.html',
  styleUrls: ['./showcase-backup-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseBackupScreenComponent {
  readonly StatusContext = StatusContext
  readonly BackupTab = ResourcesTab.BACKUP
  readonly backupScreenScenarios: ReadonlyArray<BackupScreenScenario> = buildBackupScreenScenarios()
  backupScreenScenarioKey: string = this.backupScreenScenarios[0].key

  get backupScreenActiveScenario(): BackupScreenScenario {
    return (
      this.backupScreenScenarios.find((s) => s.key === this.backupScreenScenarioKey) ?? this.backupScreenScenarios[0]
    )
  }
  get backupScreenApp(): Application {
    return this.backupScreenActiveScenario.application
  }
  get backupScreenResources() {
    return this.backupScreenActiveScenario.resources
  }
  get backupScreenStatus() {
    return this.backupScreenActiveScenario.status
  }

  get backupScreenScenarioGroups(): { group: string; label: string; scenarios: BackupScreenScenario[] }[] {
    const labelFor: Record<BackupScreenScenario['group'], string> = {
      STANDBY: 'Standby',
      FAILOVER: 'Failover (frozen)',
    }
    const groups: { group: string; label: string; scenarios: BackupScreenScenario[] }[] = []
    for (const scenario of this.backupScreenScenarios) {
      const existing = groups.find((g) => g.group === scenario.group)
      if (existing) existing.scenarios.push(scenario)
      else groups.push({ group: scenario.group, label: labelFor[scenario.group], scenarios: [scenario] })
    }
    return groups
  }

  setBackupScreenScenario(key: string): void {
    if (this.backupScreenScenarioKey === key) return
    this.backupScreenScenarioKey = key
  }
}
